export class Organization {
  UserName: string;
  SearchdropFirst: string;
  SearchdropSecond: string;
  SearchMatchesFirst: string;
  SearchMatchesSecond: string;
  SearchtextFirst: any;
  SearchtextSecond: any;
  tenantDisplayName: string = "";
  TenantId: number;
  ZipCode: string;
  MaxWeeklyHours: string;
  OrganizationCode: string;
  OrganizationName: string;
  LegalName: string;
  OwnerName: string;
  OwnerEmail: string;
  OwnerPhone: number;
  NonUSAddress: boolean;
  TaxID: number;
  Address1: string;
  AStreet: string;
  Country: string;
  City: string;
  State: string;
  Status: string;
  Province: string;
  AccountExecutive: any = "";
  AccountExecutiveNo: any = "";
  IFGuru: string;
  IFGuruEmail: string;
  IFGuruPhone: number;
  TerminationDate: any;
  StartingDate: any;
  ReasonForTermination: string;
  TerminationNotes: string;
  BCCEmail: string;
  Hotelid: number;
  PageFlag: number;
  ReportScheduleTime: number = -1;
  DigitalACS: string;
  APAutomation: boolean;
  SearchdropFirstList: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'City', Text: 'City' },
    { Value: 'State', Text: 'State' },
    { Value: 'Status', Text: 'Status' }
  ]
  SearchdropSecondList: any[] = [
    { Value: 'TenantID', Text: 'TenantID' },
    { Value: 'Pname', Text: 'Org Name' },
    { Value: 'lettercode', Text: 'Org Code' },
    { Value: 'City', Text: 'City' },
    { Value: 'State', Text: 'State' },
    { Value: 'Status', Text: 'Status' }
  ]

  ReportStartTimeList: any[] = [
    { Value: '-1', Text: 'Select' },
    { Value: '0', Text: '00:00' },
    { Value: '1', Text: '01:00' },
    { Value: '2', Text: '02:00' },
    { Value: '3', Text: '03:00' },
    { Value: '4', Text: '04:00' },
    { Value: '5', Text: '05:00' },
    { Value: '6', Text: '06:00' },
    { Value: '7', Text: '07:00' },
    { Value: '8', Text: '08:00' },
    { Value: '9', Text: '09:00' },
    { Value: '10', Text: '10:00' },
    { Value: '11', Text: '11:00' },
    { Value: '12', Text: '12:00' },
    { Value: '13', Text: '13:00' },
    { Value: '14', Text: '14:00' },
    { Value: '15', Text: '15:00' },
    { Value: '16', Text: '16:00' },
    { Value: '17', Text: '17:00' },
    { Value: '18', Text: '18:00' },
    { Value: '19', Text: '19:00' },
    { Value: '20', Text: '20:00' },
    { Value: '21', Text: '21:00' },
    { Value: '22', Text: '22:00' },
    { Value: '23', Text: '23:00' }
  ];
}




// WEBPACK FOOTER //
// ./src/app/Classes/OrganizationClass.ts